import { render, staticRenderFns } from "./AffirmAuthorsPages.vue?vue&type=template&id=6a1e3a26&"
import script from "./AffirmAuthorsPages.vue?vue&type=script&lang=js&"
export * from "./AffirmAuthorsPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports